import classNames from "classnames";
import ProductsCompareTableProductCard from "@components/ProductsCompareTable/ProductsCompareTableProductCard";
import { getProductAttributeValue } from "@components/ProductsCompareTable/lib.js";
import CloseIcon from "@components/Icons/Close";

const getProductCountClassNames = (products) =>
  classNames("grid grid-flow-col", {
    "grid-cols-[repeat(2,_minmax(200px,_50%))] md:grid-cols-[repeat(3,33.3%)] lg:grid-cols-[repeat(3,320px)]":
      products.length === 2,
    "grid-cols-[repeat(3,_minmax(200px,_33.3%))] lg:grid-cols-[repeat(4,25%)]":
      products.length === 3,
    "grid-cols-[repeat(4,_minmax(200px,_25%))] lg:grid-cols-[repeat(5,20%)]":
      products.length === 4,
  });

const getProductCardContainerClassNames = (productIndex) => {
  const isFirstProduct = productIndex === 0;

  return classNames("border-gray-1100 px-3", {
    "border-l border-r border-t border-b md:border-r md:border-t md:border-b md:border-l":
      isFirstProduct,
    "border-t border-b border-r md:border-t md:border-b md:border-r":
      !isFirstProduct,
  });
};

const getProductAttributeClassNames = (
  attributeIndex,
  attributesLength,
  productIndex
) => {
  const isFirstRow = attributeIndex === 0;
  const isEvenRow = attributeIndex % 2 === 0;
  const isFirstColumn = productIndex === 0;
  const isLastRow = attributeIndex === attributesLength - 1;

  return classNames("border-gray-1100 border-l border-r border-t border-b", {
    "bg-gray-lighter": isEvenRow,
    "bg-white": !isEvenRow,
    "border-t md:border-t": isFirstRow,
    "md:border-t-0": !isFirstRow,
    "md:border-b-0": !isLastRow,
    "md:border-b": isLastRow,
    "md:border-l-0": !isFirstColumn,
    "border-l-0": !isFirstColumn,
  });
};
const ProductsCompareTable = ({
  products,
  productsAttributeGroups,
  onProductRemove,
  canRemove = true,
  onProductClick,
}) => {
  return (
    <div className="overflow-x-scroll">
      <div
        className={classNames({
          "min-w-[400px] md:min-w-auto": products.length === 2,
          "min-w-[600px]": products.length === 3,
          "min-w-[800px] lg:min-w-auto": products.length === 4,
        })}
      >
        <div className={getProductCountClassNames(products)}>
          <div
            className={classNames("hidden", {
              "md:block": products.length === 2,
              "lg:block": products.length > 2,
            })}
          />

          {products.map((product, productIndex) => (
            <div
              key={product.sku}
              className={`relative ${getProductCardContainerClassNames(
                productIndex
              )}`}
            >
              {canRemove && (
                <button
                  className="absolute top-2 right-2 z-10 p-1 block appearance-none bg-transparent text-gray-light"
                  onClick={() => onProductRemove(product.sku)}
                >
                  <CloseIcon width="15px" height="15px" />
                </button>
              )}

              <ProductsCompareTableProductCard
                product={product}
                onRemove={onProductRemove}
                onClick={onProductClick}
              />
            </div>
          ))}
        </div>

        {productsAttributeGroups && (
          <div className="mt-6">
            {productsAttributeGroups.map((group) => (
              <div key={group.name} className="mb-12">
                {group.name && (
                  <div
                    className={classNames(
                      // bd-claim: Macan Stencil first letter (Brico only; no-op for altex/MG)
                      "lg:pb-1 text-xl lg:text-2xl text-red-brand break-words bd-claim",
                      {
                        "min-w-[400px]": products.length === 2,
                      }
                    )}
                  >
                    {group.name}
                  </div>
                )}

                {group.attributes.map((attribute, attributeIndex) => (
                  <div
                    key={attribute.attribute_code}
                    className="mt-2 mb-3 md:mt-0 md:mb-0"
                  >
                    <div
                      className={classNames("text-sm break-words mb-2", {
                        "min-w-[400px] md:hidden": products.length === 2,
                        "lg:hidden": products.length > 2,
                      })}
                    >
                      {attribute.label}
                    </div>

                    <div className={getProductCountClassNames(products)}>
                      <div className="pt-3 pb-1 hidden md:block">
                        {attribute.label}
                      </div>

                      {products.map((product, productIndex) => (
                        <div
                          key={product.sku}
                          className={`p-3 text-sm break-words ${getProductAttributeClassNames(
                            attributeIndex,
                            group.attributes.length,
                            productIndex
                          )}`}
                        >
                          {getProductAttributeValue(
                            attribute.attribute_code,
                            product,
                            group.name
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
export default ProductsCompareTable;
